import dashboard from './dashboard';
import employees from './employees';
import timesheet from './timesheet';
import expenses from './expenses';
import payroll from './payroll';
import taxApprovals from './tax-approvals';
import savings from './savings';
import support from './support';
import chartedAccount from './charted-account';

// ==============================|| MENU ITEMS ||============================== //
// import dashboard from './dashboard';
import adminDashboard from './admin-dashboard';
import organization from './organization';
import adminUsers from './admin-users';
import supportTickets from './support-tickets';
import demoRequests from './demo-requests';

const menuItems = {
    items: [
        dashboard,
        employees,
        timesheet,
        expenses,
        payroll,
        taxApprovals,
        support,
        savings,
        adminDashboard,
        chartedAccount,
        organization,
        adminUsers,
        supportTickets,
        demoRequests,
    ]
};

export default menuItems;
